import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import Input from '../../components/input/Input';
import Select from '../../components/selects/Select';
import DateComponent from '../../components/date/Date';
import { displayMessage } from '../../helpers/messages';
import api from '../../services/api';
import { showErrorMessage } from '../../services/messages';

const BatchFilters = ({ onFilter, onClear }) => {
  const [form] = Form.useForm();
  const [clients, setClients] = useState([]);

  useEffect(() => {
    loadClients();
  }, []);

  const loadClients = async () => {
    try {
      const response = await api.client.list();
      setClients(response.data);
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || displayMessage('ERROR_LOAD'));
    }
  };

  const handleFilter = (values) => {
    onFilter(values);
  };

  const handleClear = () => {
    form.resetFields();
    onClear();
  };

  const clientOptions = clients.map(client => ({
    value: client.id,
    label: client.company_name,
  }));

  const statusOptions = [
    { value: true, label: displayMessage('ACTIVE') },
    { value: false, label: displayMessage('INACTIVE') },
  ];

  return (
    <Form
      form={form}
      onFinish={handleFilter}
      layout="vertical"
      style={{ marginBottom: 16 }}
    >
      <Row gutter={16}>
        <Col xs={24} sm={12} md={6}>
          <Form.Item
            label={displayMessage('CLIENT')}
            name="by_client"
          >
            <Select
              placeholder="Selecione o cliente"
              options={clientOptions}
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Form.Item
            label={displayMessage('INVOICE_NUMBER')}
            name="by_invoice_number"
          >
            <Input placeholder="Buscar por nota fiscal" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Form.Item
            label="Data Inicial"
            name="start_date"
          >
            <DateComponent placeholder="Selecione a data inicial" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Form.Item
            label="Data Final"
            name="end_date"
          >
            <DateComponent placeholder="Selecione a data final" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12} md={6}>
          <Form.Item
            label={displayMessage('STATUS')}
            name="by_is_active"
          >
            <Select
              placeholder="Selecione o status"
              options={statusOptions}
              allowClear
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Button
            icon={<ClearOutlined />}
            onClick={handleClear}
            style={{ marginRight: 8 }}
          >
            {displayMessage('CLEAR')}
          </Button>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            htmlType="submit"
          >
            {displayMessage('FILTER')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default BatchFilters;



